<template>
  <div class="poster-box" style="display: none">
    <div class="poster-body">
      <div class="store-logo-box">
        <img :src="storeInfo.logoPath" alt="" class="store-logo" />
        <img
          src="../../assets/images/store-poster/store-authentication-icon.png"
          alt=""
          class="store-authentication-icon"
        />
      </div>
      <h5 class="store-name">
        {{ storeInfo.name }}
      </h5>
      <p class="store-year">
        - 已持续经营{{ storeYear }}年，官方认证{{ shopOrStudioTag }} -
      </p>
      <ul class="store-info">
        <li class="info-li">
          <p>资料</p>
          <div>
            <span>{{ storeData.documentCount | numberChange }}</span>
            <i v-show="storeData.documentCount > 10000">万</i>
          </div>
        </li>
        <li class="info-li">
          <p>下载量</p>
          <div>
            <span>{{ storeData.documentTotalDownload | numberChange }}</span>
            <i v-show="storeData.documentTotalDownload > 10000">万</i>
          </div>
        </li>
        <li class="info-li">
          <p>浏览量</p>
          <div>
            <span>{{ storeData.documentTotalPv | numberChange }}</span>
            <i v-show="storeData.documentTotalPv > 10000">万</i>
          </div>
        </li>
      </ul>
      <img v-show="posterType === 1" :src="WXMiniCodeUrl" alt="" class="code" />
      <img v-show="posterType === 2" :src="H5CodeUrl" alt="" class="code" />
      <p class="code-text">扫码访问{{ shopOrStudioTag }}</p>
    </div>
    <img src="../../assets/images/xkw-store-logo.png" alt="" class="logo" />
  </div>
</template>

<script>
import api from "@/assets/js/api";
export default {
  name: "ShopCenterAdminWebStorePoster",
  props: {
    storeInfo: {
      type: Object,
      default: () => {},
    },
    posterType: {
      type: Number,
      default: 1,
    },
    WXMiniCodeUrl: {
      type: String,
      default: "",
    },
    H5CodeUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      storeData: {},
      storeYear: 1,
    };
  },
  computed: {
    // 店铺或工作室
    shopOrStudioTag() {
      return this.$store.getters["user/shopOrStudioTag"];
    },
  },
  mounted() {
    this.getStoreData();
  },
  filters: {
    numberChange: (val) => {
      if (typeof val !== "number") {
        number = 0;
      }
      let number = Number(val);
      if (number >= 10000) {
        number = (Math.floor(number / 1000) / 10).toFixed(1);
      }
      return number;
    },
  },
  methods: {
    async getStoreData() {
      const res = await this.$axios.post(api.decoration.getShopState, {
        shopId: Number(this.$store.state.user.userInfo.shopId),
      });
      this.storeData = res.result;
      this.storeYear =
        Math.floor(this.storeData.day / 365) > 0
          ? Math.floor(this.storeData.day / 365)
          : 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.poster-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 750px;
  height: 1334px;
  background: url(../../assets/images/store-poster/poster-bg.png) no-repeat;
  background-size: 100% 100%;
  .poster-body {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 640px;
    height: 960px;
    border-radius: 40px;
    border: 2px solid #fff;
    background: linear-gradient(180deg, #f9fcff 0%, #fff 100%);
    .store-logo-box {
      position: absolute;
      top: -86px;
      left: 236px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 170px;
      height: 170px;
      border-radius: 170px;
      border: 2px solid #eee;
      box-shadow: 0px 10px 10px 10px rgba(224, 224, 224, 0.45);
      background: #fff;
      .store-logo {
        width: 170px;
        height: 170px;
        border-radius: 170px;
      }
      .store-authentication-icon {
        position: absolute;
        bottom: -4px;
        right: 12px;
        width: 34px;
        height: 34px;
      }
    }
    .store-name {
      width: 416px;
      height: 80px;
      margin-top: 110px;
      color: #3a3d4b;
      text-align: center;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 40px; /* 125% */
      // 两行省略
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .store-year {
      margin: 40px 0 70px;
      color: #8895a9;
      font-size: 26px;
      font-style: normal;
      font-weight: 400;
      line-height: 26px; /* 100% */
    }
    .store-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 516px;
      padding-bottom: 48px;
      border-bottom: 2px dashed #8895a9;
      .info-li {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 172px;
        & > p {
          min-width: 80px;
          margin-bottom: 10px;
          text-align: center;
          color: #3a3d4b;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px; /* 100% */
        }
        & > div {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 80px;

          & > span {
            color: #3051ff;
            font-size: 40px;
            font-style: normal;
            font-weight: 700;
            line-height: 1; /* 100% */
          }
          & > i {
            margin-left: 6px;
            // transform: translateY(1px);
            color: #3051ff;
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 1; /* 100% */
          }
        }
      }
    }
    .code {
      width: 324px;
      height: 324px;
      margin: 68px 0 52px;
    }
    .code-text {
      color: #8895a9;
      font-size: 26px;
      font-style: normal;
      font-weight: 400;
      line-height: 26px; /* 100% */
    }
  }

  .logo {
    width: 362px;
    height: 48px;
    margin: 66px 0;
  }
}
</style>
